export default __webpack_public_path__ + "static/media/project-3.9697f8bc.jpg";